import React from "react";

import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { IOSSwitch } from "../../Gen/Switch";
import "./Title.css";
export const Title = ({ Title }) => {
  const navigate = useNavigate();
  return (
    <Box className="Order">
      <Button className="OrderProduct" onClick={() => navigate(-1)}>
        <ArrowBackIosIcon className="vector" />
        <Typography className="TopTitle">Back To Order</Typography>
      </Button>
      <Box className="ProductTitle">
        <Typography className="ProductTitle">Order #{Title}</Typography>
      </Box>
    </Box>
  );
};